import { environment } from '../../environments/environment';

export function isPermittedAppUrl(url: string): boolean {
  // portal://(ホームアプリ)とflip://(学習動画アプリ)とpocketbook(授業記録アプリ)で始まるスキーマを許可
  const appSchemaRegex = new RegExp('^(portal|flip|pocketbook)://');
  // /R/:app_name/:action で定義されるリダイレクトURLを許可
  const redirectUrlRegex = new RegExp(`^${environment.domain}/R/`);
  return appSchemaRegex.test(url) || redirectUrlRegex.test(url);
}
